"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from "react";
import type React from "react";
import { useInView } from "motion/react";
import { annotate } from "rough-notation";
import { type RoughAnnotation } from "rough-notation/lib/model";
type AnnotationAction = "highlight" | "underline" | "box" | "circle" | "strike-through" | "crossed-off" | "bracket";
interface HighlighterProps {
  children: React.ReactNode;
  action?: AnnotationAction;
  color?: string;
  strokeWidth?: number;
  animationDuration?: number;
  iterations?: number;
  padding?: number;
  multiline?: boolean;
  isView?: boolean;
}
export function Highlighter(t0) {
  const $ = _c(13);
  const {
    children,
    action: t1,
    color: t2,
    strokeWidth: t3,
    animationDuration: t4,
    iterations: t5,
    padding: t6,
    multiline: t7,
    isView: t8
  } = t0;
  const action = t1 === undefined ? "highlight" : t1;
  const color = t2 === undefined ? "#ffd1dc" : t2;
  const strokeWidth = t3 === undefined ? 1.5 : t3;
  const animationDuration = t4 === undefined ? 600 : t4;
  const iterations = t5 === undefined ? 2 : t5;
  const padding = t6 === undefined ? 2 : t6;
  const multiline = t7 === undefined ? true : t7;
  const isView = t8 === undefined ? false : t8;
  const elementRef = useRef(null);
  const annotationRef = useRef(null);
  let t9;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      once: true,
      margin: "-10%"
    };
    $[0] = t9;
  } else {
    t9 = $[0];
  }
  const isInView = useInView(elementRef, t9);
  const shouldShow = !isView || isInView;
  let t10;
  let t11;
  if ($[1] !== action || $[2] !== animationDuration || $[3] !== color || $[4] !== iterations || $[5] !== multiline || $[6] !== padding || $[7] !== shouldShow || $[8] !== strokeWidth) {
    t10 = () => {
      if (!shouldShow) {
        return;
      }
      const element = elementRef.current;
      if (!element) {
        return;
      }
      const annotationConfig = {
        type: action,
        color,
        strokeWidth,
        animationDuration,
        iterations,
        padding,
        multiline
      };
      const annotation = annotate(element, annotationConfig);
      annotationRef.current = annotation;
      annotationRef.current.show();
      const resizeObserver = new ResizeObserver(() => {
        annotation.hide();
        annotation.show();
      });
      resizeObserver.observe(element);
      resizeObserver.observe(document.body);
      return () => {
        if (element) {
          annotate(element, {
            type: action
          }).remove();
          resizeObserver.disconnect();
        }
      };
    };
    t11 = [shouldShow, action, color, strokeWidth, animationDuration, iterations, padding, multiline];
    $[1] = action;
    $[2] = animationDuration;
    $[3] = color;
    $[4] = iterations;
    $[5] = multiline;
    $[6] = padding;
    $[7] = shouldShow;
    $[8] = strokeWidth;
    $[9] = t10;
    $[10] = t11;
  } else {
    t10 = $[9];
    t11 = $[10];
  }
  useEffect(t10, t11);
  let t12;
  if ($[11] !== children) {
    t12 = <span ref={elementRef} className="relative inline-block bg-transparent">{children}</span>;
    $[11] = children;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  return t12;
}